




import Vue from 'vue';
import ContentDetail from '@/components/content/content-detail.component.vue';

export default Vue.extend({
  components: {
    'content-detail': ContentDetail,
  },
});
